// extracted by mini-css-extract-plugin
export default {"infoContainer":"InfoToast_infoContainer__aFlxP","innerContainer":"InfoToast_innerContainer__lZR8k"};